/* eslint-disable */
import ReportRtpList from './report-rtp.list';

export default {
  // TODO: Temporarily use auto-render reports
  // list: ReportRtpList,
};
